import React from "react"

// @ts-ignore
import PriorityIcon from "../../../../../gd-components/priority/priority-icon/priority-icon"

export default function FieldPriority_FormValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <PriorityIcon className="fl-no-shrink m-r-10" priority={props.option.value}/>
                <span className="txt-truncate">{props.option.label}</span>
            </div>
            {props.children}
        </React.Fragment>
    )
}